import { config } from '@lingoda/config';
import { FatalError, MercureEventSource, NetworkError } from '@lingoda/event-source';
import { getAuthCheck, hasAppAuthExpCookie, hasMercureAuthCookie } from '@lingoda/auth';
import { captureMercureError } from './sentry';

export const mercureClient = new MercureEventSource(
    {
        url: config.mercurePublicUrl,
        credentials: 'include',
        fetch: async (...args) => {
            try {
                await getAuthCheck('');
            } catch {
                throw new FatalError({ cause: new AuthCheckError() });
            }

            return await window.fetch(...(args as Parameters<typeof window.fetch>));
        },
    },
    {
        enableLogger: config.deployEnvironment !== 'production',
        maxRetryAttempts: 3,
    },
);

mercureClient.onConnectionError = (error) => {
    if (error.cause instanceof AuthCheckError) {
        return;
    }

    if (error.cause instanceof NetworkError) {
        // Second auth error check, because `getAuthCheck` not throw if authTokenExpire is not found
        if (error.cause.response.status === 401 && !hasAppAuthExpCookie()) {
            return;
        }
    }

    captureMercureError(error, {
        Hub: {
            url: error.request.url,
            hasAuthCookie: hasMercureAuthCookie(),
            response: error.cause instanceof NetworkError ? error.cause.response : undefined,
        },
    });
};

mercureClient.onMessageError = (error) => {
    captureMercureError(error, {
        Message: error.msg,
    });
};

class AuthCheckError extends Error {}
